<template>
    <div class="order-wrapper">
    <div class="payment table-responsive">
            <table class="table table-borderless order-header">
            <tbody>
                <tr>
                    <td>
                        <div class="py-2">
                        <span class="d-block muted-text">ORDER PLACED</span>
                        <span>{{ formatDate(order.date) }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="py-2">
                        <span class="d-block muted-text">TOTAL</span>
                        <span>$ {{ formatPrice(order.total) }}</span>
                        </div>
                    </td>
                    <!-- <td>
                        <div class="py-2">
                        <span class="d-block text-muted">SHIP TO</span>
                        <span>N/A</span>
                        </div>
                    </td> -->
                    <td>
                        <div class="py-2 text-right">
                        <span class="d-block muted-text">ORDER # {{ order.id }}</span>
                        <span class="text-button" @click="viewOrderDetails(order.id)">View order details</span>
                        </div>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
        <div class="product table-responsive">
            <table class="table table-borderless" v-loading="refunding">
            <tbody>
                <tr v-for="product in order.products" :key="product.priceId">
                    <td width="10%">
                        <img src="../assets/images/workout.png" v-if="product.name.includes('session')" width="90">
                        <img src="../assets/images/tokens.png" v-if="product.name.includes('coin')" width="90">
                        <img class="rounded " v-if="product.name === 'Glove'" src="../assets/images/glove.png" width="90">
                        <img class="rounded" v-if="product.name === 'Knee Sleeve'" src="../assets/images/knee_sleeve.png" width="90">
                        <img class="rounded" v-if="product.name === 'Neat'" src="../assets/images/neat.png" width="90">
                        <img class="rounded" v-if="product.name === 'Pants'" src="../assets/images/knee_sleeve.png" width="90">
                        <img class="rounded" v-if="product.name === 'Band'" src="../assets/images/band.jpg" width="90">
                    </td>
                    <td width="70%">
                        <span class="font-weight-bold text-left">{{ product.name }}</span>
                        <div class="product-qty">
                        <span class="d-block mt-1">Quantity: {{ product.quantity }}</span>
                        </div>
                        <button class="btn btn-primary mt-2" @click="reorder(product)">Buy it again</button>
                        <button class="btn btn-primary mt-2 ml-2" v-if="product.refundId" disabled>Refunded</button>
                        <button class="btn btn-primary mt-2 ml-2" v-else-if="!refunding || refunding != product.priceId" @click="refund(product)">Request refund</button>
                        <button class="btn btn-primary mt-2 ml-2" disabled v-else>Processing refund</button>
                    </td>
                    <td width="20%">
                        <div class="text-right">
                        <span class="font-weight-bold">$ {{ formatPrice(product.quantity * product.unit_price) }}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
            </table>
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger mt-3" v-if="refundAlert">
              <div class="iq-alert-text">{{ refundAlert }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { httpsCallable } from 'firebase/functions'
import firebase from '../../firebase'
import SessionsProducts from '../FackApi/json/SessionsProducts.json'
import CoinsProducts from '../FackApi/json/CoinsProducts.json'
import web3Service from '../services/web3/web3Service'
import getDocument from '../services/getDocument'
import { doc, updateDoc, increment, arrayUnion, Timestamp } from 'firebase/firestore'
import { ref } from 'vue'

export default {
  props: ['order'],
  setup (props) {
    const firebasePatient = firebase.firebaseAuth.currentUser
    const issueRefund = httpsCallable(firebase.functions, 'issueRefund')
    const { getBalance, removeCoinsFromUser } = web3Service()
    const { document: walletDocument } = getDocument('web3Wallets', firebasePatient.uid)
    const { document: userDocument } = getDocument('users', firebasePatient.uid)

    const formatDate = (timestamp) => {
      const date = timestamp.toDate()
      const options = { month: 'long', day: 'numeric', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    }

    const formatPrice = (price) => {
      return (price / 100).toFixed(2)
    }

    const router = useRouter()

    const reorder = (product) => {
      if (product.name.includes('session')) {
        router.push({ name: 'patient.shopSessions' })
      } else if (product.name.includes('coin')) {
        router.push({ name: 'patient.shopCoins' })
      } else {
        router.push({ name: 'patient.shopDevices' })
      }
    }

    const viewOrderDetails = (sessionId) => {
      router.push({ name: 'patient.orderConfirmation', params: { sessionId } })
    }

    const refunding = ref(null)
    const refundAlert = ref(null)
    const refund = async (product) => {
      refunding.value = product.priceId
      refundAlert.value = null
      const session = SessionsProducts.find(session => session.priceId === product.priceId)
      if (session) {
        const value = session.value * product.quantity
        const balance = userDocument.value.purchasedSessions
        if (balance < value) {
          refundAlert.value = 'Not enough sessions balance. Refund cannot be processed.'
          refunding.value = null
          return
        } else {
          const userRef = doc(firebase.db, 'users', firebasePatient.uid)
          await updateDoc(userRef, {
            purchasedSessions: increment(-value)
          })
        }
      } else {
        const coin = CoinsProducts.find(coin => coin.priceId === product.priceId)
        const value = coin.value * product.quantity
        const balance = await getBalance(walletDocument.value.address)
        if (balance < value) {
          refundAlert.value = 'Not enough coins balance. Refund cannot be processed.'
          refunding.value = null
          return
        } else {
          const walletRef = doc(firebase.db, 'web3Wallets', firebasePatient.uid)
          await Promise.all([
            removeCoinsFromUser(walletDocument.value.address, walletDocument.value.email, value.toString()),
            await updateDoc(walletRef, {
              transactions: arrayUnion({
                name: 'Coins refund',
                timestamp: Timestamp.now(),
                type: 'out',
                value: value.toString()
              })
            })
          ])
        }
      }

      const refund = await issueRefund(
        {
          sessionID: props.order.id,
          priceId: product.priceId,
          amount: product.unit_price * product.quantity
        })
      product.refundId = refund.id
      refunding.value = null
      window.location.reload()
    }

    return {
      formatDate,
      formatPrice,
      reorder,
      viewOrderDetails,
      refund,
      refunding,
      refundAlert
    }
  }
}
</script>

<style scoped>
    .order-header {
        background-color: #F0F2F2;
    }

    .order-wrapper {
        border: 1px  solid var(--border-color);
        border-radius: 8px;
    }

    .text-button {
        color: #b583bc;
        font-weight: 600;
        cursor: pointer;
    }

    .btn {
        font-size: 12px;
        border-radius: 8px;
        box-shadow: 0 2px 5px 0 rgba(213,217,217,.5);
        margin-left: -2px;
    }
</style>
